import { Component, ViewChild } from '@angular/core';
import { ActionSheet, ActionSheetController, Content, IonicPage, LoadingController, NavController, NavParams, Popover, PopoverController, ToastController } from 'ionic-angular';
import { NuevoMenuDerechoComponent } from '../../components/nuevo-menu-derecho/nuevo-menu-derecho';
import { iConfiguracion } from '../../models/basePage';
import { PaginaBasica } from '../../models/PaginaBase';
import { APIOnLine } from '../../services/api/api.services';
import { LesionadosService } from '../../services/api/lesionados.service';
import { Proxy } from '../../services/proxy/proxy.service';
import {
  pouchdb2
} from '../../services/pouchdb/pouchdb.service';

import * as mod from '../../models/lesionados';
import { Observable } from 'rxjs';

/**
 * Generated class for the LesionadosPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-lesionados',
  templateUrl: 'lesionados.html',
})
export class LesionadosPage extends PaginaBasica {
  @ViewChild(Content) content: Content;

  // #region Propiedades del controlador
  public configuraciones: iConfiguracion;
  public designacion: Proxy.PrDesignaciones;
  public idEquipo: number;
  public licenciasLocal: Proxy.ListaPrPersonaAlineable;
  participanteLocal: Proxy.PrParticipacion;
  public participantesLocal: Proxy.ListaPrParticipacion;
  public licenciasVisitante: Proxy.ListaPrPersonaAlineable;
  participanteVisitante: Proxy.PrParticipacion;
  public participantesVisitante: Proxy.ListaPrParticipacion;

  lesionados$: Observable<mod.IActasLesiones_DTO> = this.lesionadosService.lesionados$;
  listaLesionados: mod.IActasLesionado[] = [];
  lesion: string = '';
  minuto: number = undefined;
  // #endregion

  // #region Propiedades relacionadas con los formularios de
  mostrarFormEquipoLocal: boolean = false;
  mostrarFormEquipoVisitante: boolean = false;
  sinDelegadoLocal: boolean = false;
  sinDelegadoVisitante: boolean = false;
  sinLesionesLocal: boolean = false;
  sinLesionesVisitante: boolean = false;
  conLesionesLocal: boolean = false;
  conLesionesVisitante: boolean = false;
  // #endregion

  constructor(
    public actionSheetCtrl: ActionSheetController,
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public popOverCtrl: PopoverController,
    public toastCtrl: ToastController,
    public CFutbolActas: APIOnLine.CFutbolActas,
    public DBService2: pouchdb2.DBService2,
    public Persistentes: APIOnLine.Persistentes,
    public lesionadosService: LesionadosService
  ) {
    super(loadingCtrl, toastCtrl);
  }

  ionViewDidEnter() {
    console.log("--- ENTRO EN LA PÁGINA: LESIONADOS ---");
    this.designacion = this.Persistentes.GetDesignacion();

    this.licenciasLocal = new Proxy.ListaPrPersonaAlineable(this.CFutbolActas, this.DBService2, this.Persistentes, this.designacion, this.designacion.idLocal);
    this.participantesLocal = new Proxy.ListaPrParticipacion(this.CFutbolActas, this.DBService2, this.Persistentes, this.toastCtrl, this.designacion, this.designacion.idLocal);
    this.licenciasVisitante = new Proxy.ListaPrPersonaAlineable(this.CFutbolActas, this.DBService2, this.Persistentes, this.designacion, this.designacion.idVisitante);
    this.participantesVisitante = new Proxy.ListaPrParticipacion(this.CFutbolActas, this.DBService2, this.Persistentes, this.toastCtrl, this.designacion, this.designacion.idVisitante);

    // Suscripción al observable con la información de los lesionados, para que cada vez que se cambie,
    // actualizar el valor de los campos del formulario.
    this.lesionadosService.obtenerPorDesignacion(this.designacion.urlApi, this.designacion.idDesignacion, this.designacion.idCalendario)
      .subscribe({
        next: (resultado: mod.IActasLesiones_DTO) => {
          console.log("Datos de los lesionados", resultado);
          this.inicializarForm(
            resultado.info.sinDelegadoLocal,
            resultado.info.sinDelegadoVisitante,
            resultado.info.sinLesionesLocal,
            resultado.info.sinLesionesVisitante);
          this.listaLesionados = resultado.lesionados != null ? resultado.lesionados : [];

          // Comprobación de si hay lesionado en el equipo local
          if (this.listaLesionados.length > 0 && this.listaLesionados.find(m => m.idEquipo == this.designacion.idLocal) != null) {
            this.conLesionesLocal = true;
          }
          if (this.listaLesionados.length > 0 && this.listaLesionados.find(m => m.idEquipo == this.designacion.idVisitante) != null) {
            this.conLesionesVisitante = true;
          }

          if (resultado.info.id > 0 && !resultado.info.sinLesionesLocal && !resultado.info.sinDelegadoLocal) {
            this.activarLesionados(true);
          }
          if (resultado.info.id > 0 && !resultado.info.sinLesionesVisitante && !resultado.info.sinDelegadoVisitante) {
            this.activarLesionados(false);
          }
        }
      });
  }

  ionViewWillLeave() {
    console.log("Va a salir de la página");
  }

  // #region Métodos del componente

  public AbrirMenuSecundario(event: any): void {
    let popover: Popover = this.popOverCtrl.create(NuevoMenuDerechoComponent);

    popover.present({
      ev: event,
    });
  }

  activarLesionados(esLocal: boolean): void {
    if (esLocal) {
      this.mostrarFormEquipoLocal = false;

      // Se comprueba si es necesario cargar la lista de participantes del equipo local.
      if (this.participantesLocal.lista == null || this.participantesLocal.lista.length == 0) {
        this.participantesLocal.CargarListaParticipacion()
          .then((resultado: boolean) => {
            return this.licenciasLocal.ObtenerAlineables(true, true, true);
          });
      }

    } else {
      this.mostrarFormEquipoVisitante = false;

      // Se comprueba si es necesario cargar la lista de participantes del equipo visitante.
      if (this.participantesVisitante.lista == null || this.participantesVisitante.lista.length == 0) {
        this.participantesVisitante.CargarListaParticipacion()
          .then((resultado: boolean) => {
            return this.licenciasVisitante.ObtenerAlineables(true, true, true);
          });
      }
    }
  }

  comprobarSinDelegado(esLocal: boolean): void {
    if (esLocal) {
      this.sinDelegadoLocal = !this.sinDelegadoLocal;
      if (this.sinDelegadoLocal) {
        this.desactivarLesionados(true);

        // Eliminación de los lesionados del equipo local
        this.lesionadosService.eliminarLesionadosPorEquipo(this.designacion.idLocal);
      }
    } else {
      this.sinDelegadoVisitante = !this.sinDelegadoVisitante;
      if (this.sinDelegadoVisitante) {
        this.desactivarLesionados(false);

        // Eliminación de los lesionados del equipo local
        this.lesionadosService.eliminarLesionadosPorEquipo(this.designacion.idVisitante);
      }
    }
    this.comprobarActivarLesionados(esLocal);
  }

  comprobarSinLesiones(esLocal: boolean): void {
    if (esLocal) {
      this.sinLesionesLocal = !this.sinLesionesLocal;
      if (this.sinLesionesLocal) {
        this.conLesionesLocal = false;

        // Eliminación de los lesionados del equipo local
        this.lesionadosService.eliminarLesionadosPorEquipo(this.designacion.idLocal);
      }
    } else {
      this.sinLesionesVisitante = !this.sinLesionesVisitante;
      if (this.sinLesionesVisitante) {
        this.conLesionesVisitante = false;

        // Eliminación de los lesionados del equipo local
        this.lesionadosService.eliminarLesionadosPorEquipo(this.designacion.idVisitante);
      }
    }
    this.comprobarActivarLesionados(esLocal);
  }

  comprobarConLesiones(esLocal: boolean): void {
    if (esLocal) {
      this.conLesionesLocal = !this.conLesionesLocal;
      if (this.conLesionesLocal) {
        this.sinLesionesLocal = false;
      }
    } else {
      this.conLesionesVisitante = !this.conLesionesVisitante;
      if (this.conLesionesVisitante) {
        this.sinLesionesVisitante = false;
      }
    }
    this.comprobarActivarLesionados(esLocal);
  }

  private comprobarActivarLesionados(esLocal: boolean): void {
    this.activarLesionados(esLocal);

    // Se guarda la información de los lesionados.
    this.guardar();
  }

  desactivarLesionados(esLocal: boolean): void {
    if (esLocal) {
      this.mostrarFormEquipoLocal = false;
    } else {
      this.mostrarFormEquipoVisitante = false;
    }
  }

  /**
   * Procesa la eliminación de un lesionado.
   * @param lesionado Datos del lesionado a eliminar.
   */
  eliminarLesionado(lesionado: mod.IActasLesionado): void {
    let actionSheet: ActionSheet = this.actionSheetCtrl.create({
      title: 'Eliminar lesionado',
      subTitle:
        '¿Desea eliminar del lesionado ha seleccionado?',
      buttons: [
        {
          text: 'ELIMINAR',
          handler: () => {
            this.MostrarOcultarCarga();

            this.lesionadosService.eliminarLesionado(this.designacion.urlApi, lesionado)
              .subscribe({
                next: (resultado: mod.IActasLesiones_DTO) => {
                  this.listaLesionados = resultado.lesionados;
                  this.MostrarOcultarCarga();
                }
              });
          }
        },
        {
          text: 'Cancelar',
          role: 'cancel'
        }
      ]
    });
    actionSheet.present();
  }

  /**
   * Guarda la información de los lesionados.
   */
  guardar(): void {

    // Solamente se guardarán los datos, cuando se haya indicado que no se encuentra el delegado, que no hay lesionados o que hay lesionados y estos se han indicado,
    // para cada uno de los dos equipos.
    let conLesionadosLocal: boolean = this.conLesionesLocal && this.listaLesionados.find(m => m.idEquipo == this.designacion.idLocal) != null;
    let localCorrecto: boolean = this.sinDelegadoLocal || this.sinLesionesLocal || conLesionadosLocal;
    let conLesionadosVisitante: boolean = this.conLesionesVisitante && this.listaLesionados.find(m => m.idEquipo == this.designacion.idVisitante) != null;
    let visitanteCorrecto: boolean = this.sinDelegadoVisitante || this.sinLesionesVisitante || conLesionadosVisitante;

    if (localCorrecto && visitanteCorrecto) {

      console.log("Se cumplen las condiciones para guardar los datos de los lesionados");

      this.MostrarOcultarCarga();
      this.lesionadosService.guardar(this.designacion.urlApi,
        this.sinDelegadoLocal,
        this.sinDelegadoVisitante,
        this.sinLesionesLocal,
        this.sinLesionesVisitante,
        this.listaLesionados)
        .subscribe({
          next: (resultado: mod.IActasLesiones_DTO) => {
            this.inicializarForm(
              resultado.info.sinDelegadoLocal,
              resultado.info.sinDelegadoVisitante,
              resultado.info.sinLesionesLocal,
              resultado.info.sinLesionesVisitante);
            this.listaLesionados = resultado.lesionados != null ? resultado.lesionados : [];

            this.MostrarOcultarCarga();
            this.Mensaje("Se han guardado los datos de los lesionados.", 5000);

            if (resultado.info.id > 0 && !resultado.info.sinLesionesLocal && !resultado.info.sinDelegadoLocal) {
              this.activarLesionados(true);
            }
            if (resultado.info.id > 0 && !resultado.info.sinLesionesVisitante && !resultado.info.sinDelegadoVisitante) {
              this.activarLesionados(false);
            }
          }
        });
    } else {

      if (!conLesionadosLocal && !conLesionadosVisitante) {
        // Los datos de los lesionados no son correctos, por lo que se debe eliminar el registro asociado con esta designación, si lo hubiere
        this.lesionadosService.eliminar(this.designacion.urlApi, this.designacion.idDesignacion)
          .subscribe({
            next: (resultado: boolean) => { }
          });
      }

    }
  }

  /**
   * Lista de lesionados del equipo indicado
   * @param esLocal Indica si es el equipo local
   * @returns Lista de lesionados
   */
  lesionadosPorEquipo(esLocal: boolean): mod.IActasLesionado[] {
    let equipo: number = esLocal ? this.designacion.idLocal : this.designacion.idVisitante;
    return this.listaLesionados.filter(m => m.idEquipo == equipo);
  }

  /**
   * Indica si existen lesionados en el equipo local
   * @param esLocal Indica si es el equipo local
   */
  tienelesionadosEnEquipo(esLocal: boolean): boolean {
    let equipo: number = esLocal ? this.designacion.idLocal : this.designacion.idVisitante;
    return this.listaLesionados.length > 0 && this.listaLesionados.find(m => m.idEquipo == equipo) != null;
  }

  private inicializarForm(sinDelegadoLocal: boolean, sinDelegadoVisitante: boolean, sinLesionesLocal: boolean, sinLesionesVisitante: boolean): void {
    this.sinDelegadoLocal = sinDelegadoLocal;
    this.sinDelegadoVisitante = sinDelegadoVisitante;
    this.sinLesionesLocal = sinLesionesLocal;
    this.sinLesionesVisitante = sinLesionesVisitante;
  }

  // #endregion

  // #region Métodos relacionados con los formularios de inserción de lesionados

  /**
   * Añade a la persona como posible lesionado.
   *
   * Comprueba que no esté ya en la lista de lesionados.
   * @param esLocal Indica si se desea incluir un lesionado del equipo local
   * @param participante Datos del participante que se añadirá como lesionado
   */
  aniadirComoLesionado(esLocal: boolean, participante: Proxy.PrParticipacion): void {
    // Comprueba que no esté ya en la lista de lesionados
    if (this.lesionadosService.lesionadoExistente(participante.idRegistro)) {
      this.Mensaje("La persona que ha seleccionado ya está incluida como lesionada.", 5000);
    } else {
      this.lesion = '';
      this.minuto = undefined;

      if (esLocal) {
        this.mostrarFormEquipoLocal = true;
        this.participanteLocal = participante;

        // Scroll al formulario
        let y = document.getElementById("divFormEquipoLocal").offsetTop;
        this.content.scrollTo(0, y);

      } else {
        this.mostrarFormEquipoVisitante = true;
        this.participanteVisitante = participante;

        // Scroll al formulario
        let y = document.getElementById("divFormEquipoVisitante").offsetTop;
        this.content.scrollTo(0, y);
      }
    }
  }

  cancelarLesionado(): void {
    this.mostrarFormEquipoLocal = false;
    this.mostrarFormEquipoVisitante = false;
    this.lesion = '';
    this.minuto = undefined;
  }

  /**
   * Incluye los datos de un lesionado en la información de lesiones.
   * @param esLocal Indica si el lesionado se incluirá en el equipo local.
   */
  procesarLesionado(esLocal: boolean): void {
    // Se comprueba si se ha indicado un texto para la lesión y un minuto
    if (this.lesion.trim().length == 0) {
      this.Mensaje("Es necesario que indique los datos de la lesión", 5000);
    } else if (this.minuto == undefined || this.minuto < 0) {
      this.Mensaje("El minuto de la lesión es obligatorio y debe ser mayor que cero.", 5000);
    } else {
      if (esLocal) {
        // Inserta la información del lesionado del equipo local
        let licenciaLocal: Proxy.PrPersonaAlineable = this.licenciasLocal.AlineablePorIdentificador(this.participanteLocal.identificador);
        this.MostrarOcultarCarga();
        this.lesionadosService.incluirLesionado(this.designacion.urlApi, this.participanteLocal, licenciaLocal, this.lesion, this.minuto)
          .subscribe({
            next: (resultado: mod.IActasLesiones_DTO) => {
              this.listaLesionados = resultado.lesionados;

              this.MostrarOcultarCarga();
              this.Mensaje("Lesión correctamente establecida", 5000);
              this.cancelarLesionado();

              this.guardar();
            }
          });
      } else {
        // Inserta la información del lesionado del equipo visitantes
        let licenciaVisitante: Proxy.PrPersonaAlineable = this.licenciasVisitante.AlineablePorIdentificador(this.participanteVisitante.identificador);
        this.MostrarOcultarCarga();
        this.lesionadosService.incluirLesionado(this.designacion.urlApi, this.participanteVisitante, licenciaVisitante, this.lesion, this.minuto)
          .subscribe({
            next: (resultado: mod.IActasLesiones_DTO) => {
              this.listaLesionados = resultado.lesionados;

              this.MostrarOcultarCarga();
              this.Mensaje("Lesión correctamente establecida", 5000);
              this.cancelarLesionado();

              this.guardar();
            }
          });
      }
    }
  }

  // #endregion
}



// WEBPACK FOOTER //
// ./src/pages/lesionados/lesionados.ts